'use client'

import { useEffect } from 'react'
import { useAnalytics } from '~/hooks/use-analytics'

export function ScrollTracker({ thresholds = [25, 50, 75, 100] }: { thresholds?: number[] }) {
  const { trackScrollDepth } = useAnalytics()

  useEffect(() => {
    const triggered: Record<number, boolean> = {}

    const onScroll = () => {
      const scrollTop = window.scrollY
      const docHeight = document.documentElement.scrollHeight - window.innerHeight
      const scrolledPercent = (scrollTop / docHeight) * 100

      thresholds.forEach((threshold) => {
        if (scrolledPercent >= threshold && !triggered[threshold]) {
          triggered[threshold] = true
          trackScrollDepth(Math.round(threshold))
        }
      })
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [thresholds])

  return null
}
